import React, {Component} from 'react'

import PageHeaderWrapper from '../../components/PageHeaderWrapper'
import {Button, Card, Form, notification, Popconfirm, Tabs, Tooltip, Row, Col, Drawer} from 'antd'
import {TableComp, FormUtils as GetAllFormFields} from 'sz-react-utils'
import Request, { API_URL } from '../../request'
import styles from '../Template/all/styles.less'
import moment from 'moment'
import _ from 'lodash'

import { RightsWrapper } from '../../components/_utils/utils'
const TabPane = Tabs.TabPane

@Form.create()
class AddEditAssetDrawer extends Component {
    state={
        visible:true,
        allUsers:[],
        assigned:false
    }

    loadUsers = async() =>{
        let activeUser = JSON.parse(localStorage.getItem('user'))
        let params = {
            results:10000,
            count:10000
        }
        params.sortField = 'dateOfJoining'
        params.sortOrder = 'ascend'
        params.userBranch = activeUser.userBranch
        params.active = true
        params.userType = { $ne : "Student"}
        let data = await Request.loadUser({...params, regExFilters: ['name', 'email']})
        let allUsers = []
        _.each(data.data, (user)=>{
            allUsers.push({_id:user.name, display:user.name})
        })
        
        this.setState({allUsers})
    }



    onClose = () => {
        this.setState({visible:false})
        setTimeout(()=>{
            this.props.onClose()
        },400)
    }
    componentDidMount() {
        this.loadUsers()
        let {record, form:{setFieldsValue}} = this.props
        if(record && record.assetStatus === "Assigned") {
            this.setState({assigned:true})
        }
        setTimeout(()=>{
            setFieldsValue({...record})
        },400)
    }

    handleSubmit = (e) =>{
        let {form,record} = this.props
        e.preventDefault()
        form.validateFieldsAndScroll(async(err,valData)=>{
            let values = _.clone(valData)
            let x = null
            if(record && record._id) {
                values._id = record._id
                x = await Request.updateCompanyAsset(values)
            }else {
                x = await Request.addCompanyAsset(values)
            }

            if(x.success) {
                notification.success({
                    message:x.message
                })
            }else {
                notification.error({
                    message:x.message
                })
            }
            this.onClose()
        })
    }

    render() {
        let {visible} = this.state;
        let {form:{getFieldDecorator, setFieldsValue}} = this.props
        let inputTypes = {
            fields:[
                {
                    label:'Asset Name',
                    key:'assetName',
                    type:'text',
                    required:true
                },
                {
                    label:'Asset Type',
                    key:'assetType',
                    type:'select',
                    width:180,
                    placeholder:'Asset Type',
                    options:["Laptop", "Mobile", "Desktop"],
                    required:true,
                    onChange:v=>{
                        this.props.form.setFieldsValue({assetType:v})
                    }
                },
                {
                    label:'Asset Number',
                    key:'assetNumber',
                    type:'text',
                    required:true
                },
                {
                    label:'Asset Other Details',
                    key:'assetDetails',
                    type:'textarea',
                    required:true
                },
                {
                    label:'Asset Status',
                    key:'assetStatus',
                    defaultValue:"Unassigned",
                    required:true,
                    type:'select',
                    options:["Assigned", "Unassigned", "Under Repairing", "Damaged"],
                    onChange:v=>{
                        this.props.form.setFieldsValue({assetStatus:v})
                        if(v === "Assigned") {
                            this.setState({assigned:true})
                        }else {
                            this.setState({assigned:false})
                        }
                    }
                },
                {
                    label:'Assigned To',
                    key:'assignedTo',
                    required:this.state.assigned,
                    hidden:!this.state.assigned,
                    showSearch:true,
                    type:'select',
                    options:this.state.allUsers,
                    onChange:v=>{
                        this.props.form.setFieldsValue({assignedTo:v})
                    }
                }
            ]
        }
        return (
            <Drawer title={
                <div>
                    <React.Fragment>
                        {
                            this.props.record && this.props.record._id?"Edit Asset":"Add New Asset"
                        }
                    </React.Fragment>
                </div>
            }
            placement="right"
            closable={true}
            onClose={this.onClose}
            width={800}
            visible={visible} >
                <Card>
                    <Form onSubmit={this.handleSubmit}>
                    <GetAllFormFields
                        apiurl={API_URL}
                        inputSchema={inputTypes}
                        getFieldDecorator={getFieldDecorator}
                    />
                    <Row style={{marginTop:'20px'}}>
                            <Col span={8}/>
                            <Col span={8}>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    style={{marginBottom: 10}}
                                    loading={this.props.loading}>
                                    Save
                                </Button>
                            </Col>
                            <Col span={8}/>
                    </Row>

                    </Form>
                </Card>
            </Drawer>
        )
    }
}

@Form.create()
class CompanyAssets extends Component {
  state = {
    id: '',
    total: 0,
    activeTab: '0',
    refreshChild: false,
    parentRatings: [],
    source:[],
    showAddEditAssetDrawer:false,
    record:null
  }

  apiRequest = params => {
    return new Promise(async(resolve) => {
    params.sortField = "assetNumber"
    params.sortOrder = "ascend"
    if(this.state.activeTab === "0") {
        params.assetType = "Laptop"
    }else if(this.state.activeTab === "1") {
        params.assetType = "Mobile"
    }else if(this.state.activeTab === "2") {
        params.assetType = "Desktop"
    }
    let data = await Request.getAllCompanyAssets({...params})
    this.setState({total:data.total})
    resolve(data)
    })
  }


  handleSubmit = e => {
    const {form} = this.props
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        let values = _.clone(valData)
        let x = null
        if (this.state.id) {
          values._id = this.state.id
          x = await Request.updateShiftTiming(values) //For Updating Data
        } else {
        x = await Request.addShiftTiming(values)
        }

        if (!x.error) {
          this.setState({
            id: '',
          })
          notification.success({
            message: x.message
          })
          if (!this.state.id) {
            form.setFieldsValue({
              startTime: '',
              endTime: '',
            })
            this.setState({activeTab:'0'})
          }
          if (this.table && this.table.current)
            this.table.current.reload()

        } else {
          notification.error({
            message: 'Error Saving',
            description: x.msg
          })
        }
      }
    })
  }



  deleteAssetDetail = async(data) =>{
    let response = await Request.deleteCompanyAsset(data);
    if(response.success) {
        notification.success({
            message:response.message
          })
    }else {
        notification.error({
          message:response.message
        })
      }
      this.table.current.reload()
  }

  callback = (value) => {
    if (value) {
      this.chooseTab(value)
    }
  }

  setAssetDetailsData(assetDetail) {
    this.setState({showAddEditAssetDrawer:true, record:assetDetail})
  }

  refreshFxn = () => {
    this.setState({refreshChild: !this.state.refreshChild})
  }

  closeAssetDrawer = () =>{
    this.setState({showAddEditAssetDrawer:false, record:null})
    this.table.current.reload()
  }

  componentWillMount() {
    
  }

  async componentDidMount() {
  }

  addEditAsset() {
    this.setState({showAddEditAssetDrawer:true})
  }
  constructor(props) {
    super(props)
    this.table = React.createRef()
  }
  chooseTab(value) {
    this.setState({
        activeTab: value
    })
    this.table.current.reload()
  }
  render() {
    const {
      form: {getFieldDecorator}
    } = this.props
    const {id} = this.state;

    const columns = [
        {
            title:'Asset Name',
            key:'assetName',
            searchTextName: 'Asset Name',
            filterRegex: true,
        },
        {
            title:'Asset Number',
            key:'assetNumber',
            searchTextName: 'Asset Number',
            filterRegex: true,
        },
        {
            title:'Asset Status',
            key:'assetStatus',
            filters:[
              {value: 'Assigned', text: 'Assigned'},
              {value: 'Unassigned', text: 'Unassigned'},
              {value: 'Under Repairing', text: 'Under Repairing'},
              {value: 'Damaged', text: 'Damaged'},

            ]
        },
        {
            title:'Assigned To',
            key:'assignedTo',
            render:(text,record)=>(
                record.assignedTo?
                <div>{record.assignedTo}</div>
                :""
            )
        },
        {
            title:'Asset Details',
            key:'assetDetails'
        },
      {
        title: 'Added By',
        key: 'createdByName',
        dataIndex: 'createdByName',
        render: (text, record) => {
          return (
            <div>
              <div>{record.updatedByUser != null ? record.updatedByUser.name : record.createdByUser != null ? record.createdByUser.name : ""}</div>
              <small>{record.updatedByUser ? moment(record.updatedByUser.time).format('lll') : record.createdByUser ? moment(record.createdByUser.time).format('lll') : '' }</small>
            </div>
          )
        }
      },
      {
        title: 'Action',
        key: 'operation',
        render: (text, record) => (
          record.businessId?
          <React.Fragment>
            <RightsWrapper myRight={'companyAssets.edit'}>
              <Tooltip title="Edit Asset Detail">
                <Button
                  className={styles.btn}
                  shape="circle"
                  onClick={() => {
                    this.setAssetDetailsData(record)
                  }}
                  icon="edit"
                />
              </Tooltip>
            </RightsWrapper>
            <RightsWrapper myRight={'companyAssets.delete'}>
              <Tooltip title="Delete Asset Detail">
                <Popconfirm
                  title="Are you sure delete this Company Asset?"
                  onConfirm={() => {
                    this.deleteAssetDetail({_id:record._id})
                  }}
                  okText="Yes"
                  cancelText="No">
                  <Button
                    className={styles.btn}
                    shape="circle"
                    icon="delete"
                  />
                </Popconfirm>
              </Tooltip>
            </RightsWrapper>
          </React.Fragment>
          :null
        )
      }
    ]
    return (
      <PageHeaderWrapper title={` Company Assets `}>
        {
            this.state.showAddEditAssetDrawer?
            <AddEditAssetDrawer record={this.state.record} onClose={this.closeAssetDrawer} />
            :null
        }
        <Card bordered={true}>
        <Row>
            <Col span={22}></Col>
            <Col span={2}>
                <Button type='primary' onClick={() =>this.addEditAsset()}>Add Asset</Button>
            </Col>
        </Row>
          <Tabs onChange={this.callback} type="card" activeKey={this.state.activeTab}>
            <TabPane tab={`All Laptops`} key={0}>
              <h2>{`Total : ${this.state.total}`}</h2>
              <TableComp
                ref={this.table}
                columns={columns}
                apiRequest={this.apiRequest}
                extraProps={{scroll: {x: 900}}}
                pagination={{
                  showSizeChanger: true,
                  defaultPageSize: 50,
                  pageSizeOptions: ['10', '20', '50', '100', '1000']
                }}
              />
            </TabPane>
            <TabPane tab={`All Mobiles`} key={1}>
              <h2>{`Total : ${this.state.total}`}</h2>
              <TableComp
                ref={this.table}
                columns={columns}
                apiRequest={this.apiRequest}
                extraProps={{scroll: {x: 900}}}
                pagination={{
                  showSizeChanger: true,
                  defaultPageSize: 50,
                  pageSizeOptions: ['10', '20', '50', '100', '1000']
                }}
              />
            </TabPane>
            <TabPane tab={`All Desktops`} key={2}>
              <h2>{`Total : ${this.state.total}`}</h2>
              <TableComp
                ref={this.table}
                columns={columns}
                apiRequest={this.apiRequest}
                extraProps={{scroll: {x: 900}}}
                pagination={{
                  showSizeChanger: true,
                  defaultPageSize: 50,
                  pageSizeOptions: ['10', '20', '50', '100', '1000']
                }}
              />
            </TabPane>
          </Tabs>
        </Card>
      </PageHeaderWrapper>
    );
  }
}

export default CompanyAssets
